/*
 * @Author: liujunhong
 * @Date: 2023/7/3
 * @Desc: 通用请求
 */


import { post } from '@/utils/request';
import { MAP_SITE_URL } from '@/constants';

export const logRequest = (data: { url: string, source:string }) => {
  return post(`${MAP_SITE_URL.API_CLOUD_URL}/www/404/log `, {...data});

}